import UsersBasicInfoSection from "../Users/UsersBasicInfoSection";

const StaffingBasicInfo = () =>{ 
    return(
        <>
        <UsersBasicInfoSection />
        </>
    )
}
export default StaffingBasicInfo;